import { createApiAction } from 'src/api';

export const FETCH_METRC_RECEIPTS_START = 'metrc/fetch_metrc_receipts_start';
export const FETCH_METRC_RECEIPTS_SUCCESS =
  'metrc/fetch_metrc_receipts_success';
export const FETCH_METRC_RECEIPTS_FAILURE =
  'metrc/fetch_metrc_receipts_failure';

export const fetchMetrcReceipts = ({ customer }) => {
  return createApiAction(
    {
      path: `/api/v1/accounts/${customer}/get_metric_info/`,
      method: 'GET',
    },
    [
      FETCH_METRC_RECEIPTS_START,
      FETCH_METRC_RECEIPTS_SUCCESS,
      FETCH_METRC_RECEIPTS_FAILURE,
    ]
  );
};
